<!--
 * @Author: 吴作杰 15727841808@163.com
 * @Date: 2023-10-10 18:01:21
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2023-10-19 11:47:45
 * @FilePath: /chaoyongtuan/src/views/teamManage/performanceManage/components/tableCells/stallInfo.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div class="stallin-info">
		<div class="has-claim-content flex">
			<yx-avatar class="avatar-img mr-8" :src="row.avatar_url" />
			<div class="has-claim-right">
				<el-tooltip placement="top" :content="row.partner_name" v-ak-tooltip-auto-show :open-delay="300">
					<p class="nick-name fz-12 line-ellipsis-1" style="max-width: 60px">{{ row.partner_name | formatEmpty }}</p>
				</el-tooltip>
				<el-tooltip placement="top" :content="row.deptName" v-ak-tooltip-auto-show :open-delay="300">
					<p class="depart-ment line-ellipsis-1 fz-12" style="max-width: 100px">部门：{{ row.deptName | formatEmpty }}</p>
				</el-tooltip>
				<el-tag v-if="row.deleted" type="danger" size="mini" effect="plain">已删除</el-tag>
				<el-tag class="mt-4 ml-8" v-else-if="row.use_status == 2" type="danger" size="mini">已停用</el-tag>
			</div>
		</div>
	</div>
</template>
<script>
import mixin from '@/components/tableCells/mixin';
export default {
	mixins: [mixin],
	components:{
		
	},
	data() {
		return {
			default_image: require('@/assets/default_avatar.png')
		};
	},
};
</script>
<style lang="less" scoped>
.has-claim-content {
	align-items: center;
	.avatar-img {
		width: 40px;
		height: 40px;
		border-radius: 50%;
	}
	.nick-name {
		color: @color-gy9;
		font-family: 'Barlow-SemiBold';
	}
	.depart-ment {
		color: @color-gy7;
		font-family: 'PingFangSC-Regular';
	}
}
</style>
